export const DEFAULT_APPSFLYER_HOST = "link.bounce.com"
export const APPSFLYER_ONELINK_SUBDOMAINS = ["usebounce.onelink.me"]
export const APPSFLYER_BRANDED_DOMAINS = [DEFAULT_APPSFLYER_HOST]
export const APPSFLYER_DOMAINS = [...APPSFLYER_ONELINK_SUBDOMAINS, ...APPSFLYER_BRANDED_DOMAINS]
